/* Registrační formuláře – AJAX odeslání (e-mail + Google Sheet přes backend). */
(function () {
	var forms = document.querySelectorAll('form.prisaha-form');
	if (!forms.length || typeof MyAjax === 'undefined') return;

	Array.prototype.forEach.call(forms, function (form) {
		var msg = form.querySelector('.form-message');

		function showMsg(text, ok) {
			if (!msg) { return; }
			msg.style.display = 'block';
			msg.style.padding = '12px 14px';
			msg.style.borderRadius = '2px';
			msg.style.marginTop = '14px';
			msg.style.fontSize = 'var(--fs-sm)';
			msg.style.background = ok ? 'rgba(31,138,91,.1)' : 'var(--red-soft)';
			msg.style.color = ok ? 'var(--green)' : 'var(--red-600)';
			msg.textContent = text;
		}

		function post(fd) {
			fetch(MyAjax.ajaxurl, { method: 'POST', body: fd, credentials: 'same-origin' })
				.then(function (r) { return r.json(); })
				.then(function (res) {
					if (res && res.success) {
						showMsg((res.data && res.data.message) || res.data || 'Děkujeme, přihlášku jsme přijali.', true);
						form.reset();
					} else {
						showMsg((res && (res.data && res.data.message || res.data)) || 'Odeslání se nezdařilo.', false);
					}
				})
				.catch(function () { showMsg('Odeslání se nezdařilo. Zkuste to prosím znovu.', false); })
				.finally(function () { window.prisahaFormEnd(form); });
		}

		form.addEventListener('submit', function (e) {
			e.preventDefault();

			// Zamknout tlačítko hned – reCAPTCHA i odeslání chvíli trvají.
			if (!window.prisahaFormStart(form)) { return; }

			var fd = new FormData(form);
			fd.append('action', form.getAttribute('data-action') || 'prisaha_registration');
			fd.append('nonce', MyAjax.nonce);

			if (window.grecaptcha && MyAjax.recaptcha_site_key) {
				grecaptcha.ready(function () {
					grecaptcha.execute(MyAjax.recaptcha_site_key, { action: 'registration' })
						.then(function (token) {
							fd.append('recaptcha_response', token);
							post(fd);
						})
						// Když reCAPTCHA selže, odešli bez tokenu – jinak by tlačítko
						// zůstalo zamčené a formulář by se nedal odeslat vůbec.
						.catch(function () { post(fd); });
				});
			} else {
				post(fd);
			}
		});
	});
})();
